<cosmos-section
  [loading]="loading"
  class="cosmos-element-summary__section"
>
  <cosmos-expandable-panel
    [accordionItems]="accordionData"
    [numberOfColumns]="2"
    panelTitle="Element Details"
  ></cosmos-expandable-panel>
</cosmos-section>

<ng-template #isFeaturedSlider>
  <div
    *ngIf="isFeatured"
    class="cosmos-element-summary__information-wrapper"
  >
    <span class="cosmos-element-summary__label">Is Featured:</span>
    <mat-slide-toggle [formControl]="isFeatured"></mat-slide-toggle>
  </div>
</ng-template>

<ng-template #isOnboardedSlider>
  <div
    *ngIf="isOnboarded"
    class="cosmos-element-summary__information-wrapper"
  >
    <span class="cosmos-element-summary__label">Is Onboarded:</span>
    <mat-slide-toggle [formControl]="isOnboarded"></mat-slide-toggle>
  </div>
</ng-template>

<ng-template #url>
  <div class="cosmos-element-summary__information-wrapper">
    <span class="cosmos-element-summary__label">
      Share URL:
      <button
        [cdkCopyToClipboard]="element.shareUrl!"
        class="cosmos-element-summary__label__button"
      >
        <mat-icon>
          <span class="cosmos-element-summary__label__button__icon">content_copy</span>
        </mat-icon>
      </button>
    </span>
  </div>
</ng-template>

<ng-template #userDetailsButton>
  <a
    (click)="openOwnerDetails()"
    class="cosmos-element-summary__pointer"
  >
    <span class="cosmos-element-summary__label">
      Owner ID:
      <span class="cosmos-element-summary__label__data-underline">{{ element.ownerId }}</span>
    </span>
  </a>
</ng-template>

<ng-template #sourceLink>
  <a
    href="{{ element.url }}"
    target="_blank"
    rel="noreferrer noopener"
    class="cosmos-element-summary__pointer"
  >
    <span class="cosmos-element-summary__label">
      Source:
      <span
        *ngIf="element.url"
        class="cosmos-element-summary__label__data-underline"
      >
        Open in new tab
      </span>
    </span>
  </a>
</ng-template>
